import mutations from './breadCrumbMutations';
import actions from './breadCrumbActions';
import getters from './breadCrumbGetters';

const state = {
  userMenus: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/common/breadCrumb/breadCrumbStore.js